export const DEFAULT_TEXT_SETTINGS = {
    fontSizePct: 100,
    lineHeight: 1.5,
    textAlign: 'start',
    marginPct: 6,
    columnGap: 48,
    columns: 1,
    theme: 'light',
    publisherStyles: true,
    fontFamily: 'original',
    dimImages: false,
    endBehavior: 'continuous',
    verticalText: 'auto',
    flowMode: 'paged',
    chromeGesture: 'handle',
};
//# sourceMappingURL=types.js.map